import { SET_ACCOUNT_CONFIRMATION } from "./constants";

export function setAccountConfirmation(code, cbSuccess, cbFailed) {
    return {
        type: SET_ACCOUNT_CONFIRMATION,
        code,
        cbSuccess,
        cbFailed
    }
}